import classNames from 'classnames';
import SelectionBase from 'components/Forms/SelectionBase';
import { FunctionComponent, useState } from 'react';
import { SelectOption } from 'types';
import styles from './SubmitButtons.module.scss';

enum DuplicateMenuOption {
  DUPLICATE = 'duplicate',
  DUPLICATE_AS_LEASE_EXTENSION = 'duplicateLeaseExtension',
}

interface Props {
  disabled?: boolean;
  duplicateLabel: string;
  duplicateLeaseExtensionLabel: string;
  onDuplicate: () => void;
  onDuplicateLeaseExtension: () => void;
}

const DuplicateSplitButton: FunctionComponent<Props> = ({
  disabled,
  duplicateLabel,
  duplicateLeaseExtensionLabel,
  onDuplicate,
  onDuplicateLeaseExtension,
}) => {
  const duplicateMenuOptions: SelectOption[] = [
    { label: duplicateLabel, value: DuplicateMenuOption.DUPLICATE },
    { label: duplicateLeaseExtensionLabel, value: DuplicateMenuOption.DUPLICATE_AS_LEASE_EXTENSION },
  ];

  const [selectedDuplicateMenuOption, setSelectedDuplicateMenuOption] = useState<DuplicateMenuOption>(
    DuplicateMenuOption.DUPLICATE
  );

  const isDuplicateMenuOptionDuplicate = selectedDuplicateMenuOption === DuplicateMenuOption.DUPLICATE;

  const onDuplicateMenuChange = (value: DuplicateMenuOption) => {
    setSelectedDuplicateMenuOption(value);
  };

  const onPrimaryClick = () => {
    if (isDuplicateMenuOptionDuplicate) {
      onDuplicate();
    } else {
      onDuplicateLeaseExtension();
    }
  };

  return (
    <div className={classNames(styles.splitButtonGroup, styles.buttonTopSpacing)}>
      <button
        className={classNames(styles.secondaryButton, styles.splitLeft)}
        onClick={onPrimaryClick}
        type="button"
        disabled={disabled}
      >
        {isDuplicateMenuOptionDuplicate ? duplicateLabel : duplicateLeaseExtensionLabel}
      </button>
      <div className={styles.splitRight}>
        <SelectionBase
          options={duplicateMenuOptions}
          onChange={onDuplicateMenuChange}
          placeholder=""
          disabled={disabled}
          classes={{ root: styles.secondaryButtonToggle, select: styles.secondaryButtonToggleSelect }}
          customStyles={{
            singleValue: (s) => ({ ...s, display: 'none' }),
            placeholder: (s) => ({ ...s, display: 'none' }),
            input: (s) => ({ ...s, display: 'none' }),
            control: (s) => ({ ...s, border: 'none', boxShadow: 'none' }),
            valueContainer: (s) => ({ ...s, padding: 0 }),
            indicatorsContainer: (s) => ({ ...s }),
            container: (s) => ({ ...s, width: '36px' }),
            menu: (s) => ({ ...s, minWidth: 260, right: 0, left: 'auto' }),
          }}
          openMenuOnClick={true}
          isSearchable={false}
          menuPlacement="bottom"
          menuPosition="absolute"
        />
      </div>
    </div>
  );
};

export default DuplicateSplitButton;
